// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IFieldStateType } from './IFieldStateType';
import {
    IFieldStateTypeFromJSON,
    IFieldStateTypeFromJSONTyped,
    IFieldStateTypeToJSON,
    IFieldStateTypeToJSONTyped,
} from './IFieldStateType';

/**
 * 
 * @export
 * @interface ICheckFundingModelInfoDto
 */
export interface ICheckFundingModelInfoDto {
    /**
     * 
     * @type {string}
     * @memberof ICheckFundingModelInfoDto
     */
    check_funding_model: string;
    /**
     * 
     * @type {IFieldStateType}
     * @memberof ICheckFundingModelInfoDto
     */
    check_funding_model_state?: IFieldStateType;
}



/**
 * Check if a given object implements the ICheckFundingModelInfoDto interface.
 */
export function instanceOfICheckFundingModelInfoDto(value: object): value is ICheckFundingModelInfoDto {
    if (!('check_funding_model' in value) || value['check_funding_model'] === undefined) return false;
    return true;
}

export function ICheckFundingModelInfoDtoFromJSON(json: any): ICheckFundingModelInfoDto {
    return ICheckFundingModelInfoDtoFromJSONTyped(json, false);
}

export function ICheckFundingModelInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICheckFundingModelInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'check_funding_model': json['check_funding_model'],
        'check_funding_model_state': json['check_funding_model_state'] == null ? undefined : IFieldStateTypeFromJSON(json['check_funding_model_state']),
    };
}

export function ICheckFundingModelInfoDtoToJSON(json: any): ICheckFundingModelInfoDto {
    return ICheckFundingModelInfoDtoToJSONTyped(json, false);
}

export function ICheckFundingModelInfoDtoToJSONTyped(value?: ICheckFundingModelInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'check_funding_model': value['check_funding_model'],
        'check_funding_model_state': IFieldStateTypeToJSON(value['check_funding_model_state']),
    };
}

